import React from 'react';

const ConnectEmbeddedAbout = () => {
  return (
    <div className="about-content">
      <h3>Documentation</h3>
      <ul>
        <li>
          <a href="https://docs.stripe.com/connect/connect-embedded-components/quickstart" target="_blank" rel="noopener noreferrer">
            Quickstart
          </a>
        </li>
      </ul>
    </div>
  );
};

export default ConnectEmbeddedAbout;
